import { useEffect, useState } from "react";
import api from "./api";

let cache = null;
let pending = null;

// Dati legali del titolare + configurazione cookie: arrivano dal backend (variabili .env)
export function useSiteInfo() {
  const [info, setInfo] = useState(cache);

  useEffect(() => {
    if (cache) return;
    if (!pending) pending = api.get("/site-info").then((r) => (cache = r.data));
    pending.then(setInfo).catch(() => {});
  }, []);

  return info;
}

export const COOKIE_CONSENT_KEY = "dlc_cookie_consent";
export const openCookiePreferences = () => window.dispatchEvent(new Event("cookie:preferences"));
